import React, { useMemo } from "react";
import { Chart } from "react-google-charts";
import ShimmerLoader from "../../Loader/ShimmerLoader";

const colors = ["#6f75eb", "#FF9900"]; // Net Sales = Blue, Shipping & Taxes = Orange

const GoogleSalesDonutChart = ({ totalSales, netSales, width = "100%", height = "230px", loading }) => {
  const shippingAndTaxes = totalSales - netSales;

  const chartData = useMemo(() => {
    if (loading || totalSales <= 0 || netSales < 0) return [];
    return [
      ["Type", "Amount"],
      ["Net Sales", netSales],
      ["Shipping & Taxes", shippingAndTaxes],
    ];
  }, [totalSales, netSales, loading]);

  const options = useMemo(() => ({
    pieHole: 0.65,
    is3D: false,
    backgroundColor: "transparent",
    pieSliceBorderColor: "#fff",
    pieSliceText: "none",
    sliceVisibilityThreshold: 0,
    chartArea: { left: 7, top: 0, bottom: -8, width: "51%", height: "70%" },
    legend: { position: "none" },
    colors: colors,
  }), []);

  const hasValidData = chartData.length > 1;

  return (
    <div style={styles.container}>
      <div style={styles.legendContainer}>
        {loading || !hasValidData ? (
          Array(2).fill().map((_, index) => (
            <ShimmerLoader key={index} width="120px" height="16px" borderRadius="4px" />
          ))
        ) : (
          chartData.slice(1).map(([label], index) => (
            <div key={index} style={styles.legendItem}>
              <span style={{ ...styles.legendColor, backgroundColor: colors[index] }}></span>
              <span style={styles.legendText}>{label}</span>
            </div>
          ))
        )}
      </div>

      <div style={styles.chartContainer}>
        {loading || !hasValidData ? (
          <div style={{ width: "100%", marginLeft: "40px" }}>
            <ShimmerLoader width="150px" height="150px" borderRadius="50%" />
          </div>
        ) : (
          <Chart
            chartType="PieChart"
            width={width}
            height={height}
            data={chartData}
            options={options}
          />
        )}
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "10px",
    padding: "5px",
  },
  legendContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "5px",
  },
  legendItem: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  legendColor: {
    width: "12px",
    height: "12px",
    borderRadius: "50%",
  },
  legendText: {
    color: "var(--text-color-1)",
    fontSize: "var(--font-size-small)",
    fontWeight: "var(--font-weight-medium)",
    marginTop: 1,
  },
  chartContainer: {
    alignSelf: "left",
  },
};

export default GoogleSalesDonutChart;
